import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';

export interface IRouteUrlHistory {
  previousRoute: string;
  currentRoute: string;
}
/**
 * Saves the current URL before changing the route.
 * https://stackoverflow.com/questions/56857880/how-to-get-history-and-match-in-this-props-in-nextjs
 */
const useRouteUrlHistory = (): IRouteUrlHistory => {
  const [previousRoute, setPreviousRouter] = useState('');
  const router = useRouter();

  const handleBeforeHistoryChange = useCallback(
    url => {
      const [nextUrl] = url?.split('?') || [];

      if (nextUrl !== router.asPath) {
        setPreviousRouter(router.asPath);
      }
    },
    [router]
  );

  useEffect(() => {
    router.events.on('beforeHistoryChange', handleBeforeHistoryChange);

    return () => {
      router.events.off('beforeHistoryChange', handleBeforeHistoryChange);
    };
  }, [handleBeforeHistoryChange, router.events]);

  return { previousRoute, currentRoute: router.asPath };
};

export default useRouteUrlHistory;
